import { useEffect } from "react";
import SEOMeta from "components/SEOMeta";
import { brandConfig } from "config/brandConfig";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";

export default function MentionsLegales() {
  const lastUpdated = "25 août 2025"; // à mettre à jour si besoin
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil", href: "/" }, { label: "Mentions légales" }]);
  }, [setItems]);

  return (
    <>
      <SEOMeta
        title="Mentions légales"
        description={`Consultez les mentions légales de ${brandConfig.brandName}, votre marque de confiance pour les armoires à fusils sécurisées.`}
      />
      <main
        role="main"
        style={{ maxWidth: 960, margin: "0 auto", padding: "24px 16px" }}
      >
        <h1 style={{ marginTop: 12 }}>Mentions légales</h1>
        <p style={{ fontSize: 14, opacity: 0.8, marginTop: 4 }}>
          Dernière mise à jour : {lastUpdated}
        </p>

        <section id="editeur" style={{ marginTop: 24 }}>
          <h2>Informations sur l’éditeur du site</h2>
          <p>
            <strong>Zamyk Sàrl</strong>
          </p>
          <address style={{ fontStyle: "normal" }}>
            Avenue des Boveresses 28, 1010 Lausanne, Suisse
          </address>
          <ul>
            <li>Forme juridique : Société à responsabilité limitée (Sàrl)</li>
            <li>
              IDE : <em>CHE-154.918.158</em>
            </li>
            <li>
              Registre du commerce : <em>RC Vaud</em>
            </li>
            <li>
              E-mail :{" "}
              <a href="mailto:contact@thetresorsafe.com">
                contact@thetresorsafe.com
              </a>
            </li>
            <li>
              Téléphone : <a href="tel:+41215190898">+41 21 519 08 98</a>
            </li>
          </ul>
        </section>

        <section id="direction" style={{ marginTop: 24 }}>
          <h2>Direction de la publication</h2>
          <p>
            Responsable de la publication : <em>Clément Forestier / associé</em>
          </p>
        </section>

        <section id="hebergeur" style={{ marginTop: 24 }}>
          <h2>Hébergement du site</h2>
          <p>
            <em>OVH</em>
            <br />
            <em>2 RUE KELLERMANN 59100 ROUBAIX</em>
            <br />
          </p>
        </section>

        <section id="propriete-intellectuelle" style={{ marginTop: 24 }}>
          <h2>Propriété intellectuelle</h2>
          <p>
            L’ensemble des contenus présents sur ce site (textes, images, logos,
            vidéos, documents téléchargeables, etc.) est la propriété exclusive
            de <strong>Zamyk Sàrl</strong>, sauf mention contraire. Toute
            reproduction, représentation, modification, distribution ou
            exploitation, totale ou partielle, est interdite sans autorisation
            écrite préalable.
          </p>
        </section>

        <section id="responsabilite" style={{ marginTop: 24 }}>
          <h2>Responsabilité</h2>
          <p>
            <strong>Zamyk Sàrl</strong> met tout en œuvre pour assurer
            l’exactitude et la mise à jour des informations diffusées sur le
            site. Elle ne saurait toutefois être tenue responsable d’erreurs,
            d’omissions, d’indisponibilités temporaires ou de tout dommage
            résultant de l’utilisation du site.
          </p>
          <p>
            Les liens hypertextes vers des sites tiers sont fournis à titre
            informatif.
            <strong> Zamyk Sàrl</strong> n’exerce aucun contrôle sur leur
            contenu et décline toute responsabilité à cet égard.
          </p>
        </section>

        <section id="donnees" style={{ marginTop: 24 }}>
          <h2>Protection des données</h2>
          <p>
            Les données personnelles collectées via ce site sont traitées
            conformément à la législation suisse, notamment la{" "}
            <strong>LPD (Loi fédérale sur la protection des données)</strong>.
            Pour plus d’informations (types de données, finalités, bases
            légales, durées de conservation, droits des personnes, etc.),
            veuillez consulter notre{" "}
            <a href="/politique-de-confidentialite">
              Politique de confidentialité
            </a>
            .
          </p>
        </section>

        <section id="cookies" style={{ marginTop: 24 }}>
          <h2>Cookies</h2>
          <p>
            Le site peut utiliser des cookies et technologies similaires à des
            fins de mesure d’audience et d’amélioration de l’expérience
            utilisateur. Vous pouvez gérer vos préférences dans le bandeau de
            consentement ou via les paramètres de votre navigateur. Pour en
            savoir plus, consultez notre
            <a href="/politique-de-confidentialite#cookies">
              {" "}
              Politique de confidentialité (section Cookies)
            </a>
            .
          </p>
        </section>

        <section id="droit-applicable" style={{ marginTop: 24 }}>
          <h2>Droit applicable et for</h2>
          <p>
            Les présentes mentions légales sont régies par le{" "}
            <strong>droit suisse</strong>. En cas de litige, les tribunaux
            compétents sont ceux du canton de Vaud, sous réserve de recours au
            Tribunal fédéral.
          </p>
        </section>

        <section id="contact" style={{ marginTop: 24 }}>
          <h2>Contact</h2>
          <p>
            Pour toute question, vous pouvez contacter{" "}
            <strong>Zamyk Sàrl</strong> :
            <br />
            E-mail :{" "}
            <a href="mailto:contact@thetresorsafe.com">
              contact@thetresorsafe.com
            </a>{" "}
            — Téléphone : <a href="tel:+41215190898">+41 21 519 08 98</a>
          </p>
        </section>
      </main>
    </>
  );
}
